export const surveySchema = {
  scenario: [{
    name: 'appScenario',
    value: 'Survey App Activity',
    activity: [{
      name: 'appActivity',
      value: 'Survey Activity logger',
    }],
  }],
};

export const pmaxLiteSchemas = {
  scenario: [
    {
      name: 'defaultScenario',
      value: 'Default Scenario',
      activity: [{
        name: 'logger',
        value: 'Default logger of default scenario',
      }],
    },
    {
      name: 'appPreloadScenario',
      value: 'App preload Scenario',
      activity: [
        {
          name: 'appPreload',
          value: 'App preload',
        },
      ],
    },
    {
      name: 'signupFlowScenario',
      value: 'signup flow',
      activity: [
        {
          name: 'signupFlow',
          value: 'signup flow',
        },
      ],
    },
    {
      name: 'customerJourneyScenario',
      value: 'customer journey',
      activity: [
        {
          name: 'customerJourney',
          value: 'customer journey',
        },
      ],
    },
    {
      name: 'usageReport',
      value: 'UsageReport Scenario',
      activity: [
        {
          name: 'signUpBundleLogin',
          value: 'Login sign up bundle',
        }, {
          name: 'signUpBundleResume',
          value: 'Resume sign up bundle',
        },
      ],
    },
    {
      name: 'overreactRequest',
      value: 'Overreact Request',
      activity: [
        {
          name: 'logger',
          value: 'Overreact Request logger',
        },
      ],
    },
    {
      name: 'pmaxLiteLanding',
      value: 'Pmax Lite Landing Scenario',
      activity: [
        {
          name: 'logger',
          value: 'Pmax Lite Landing logger',
        },
      ],
    },
    {
      name: 'pmaxLiteSignup',
      value: 'Pmax Lite Signup Scenario',
      activity: [
        {
          name: 'scope',
          value: 'Scope Change logger',
        }, {
          name: 'supportControl',
          value: 'Support Control logger',
        }, {
          name: 'userCreation',
          value: 'User Creation logger',
        }, {
          name: 'smartPageStep',
          value: 'Smart Page Step logger',
        }, {
          name: 'cancelDialog',
          value: 'Cancel dialog logger',
        }, {
          name: 'coupon',
          value: 'Coupon logger',
        }, {
          name: 'suggestion',
          value: 'Suggestion service logger',
        }, {
          name: 'addFundsStep',
          value: 'Add Funds Step logger',
        }, {
          name: 'collectBusinessInfoStep',
          value: 'Collect Business Info Step logger',
        }, {
          name: 'languageCountryStep',
          value: 'Language Country Step logger',
        }, {
          name: 'websiteStep',
          value: 'Website Step logger',
        }, {
          name: 'campaignModeStep',
          value: 'Campaign Mode Step logger',
        }, {
          name: 'conversionUpsellStep',
          value: 'Conversion Upsell Step logger',
        }, {
          name: 'currencyCountryMapping',
          value: 'CurrencyCountryMapping logger',
        }, {
          name: 'readSupportedCountryList',
          value: 'SupportedCountryList logger',
        },
      ],
    },
    {
      name: 'pmaxLiteAdAssets',
      value: 'Pmax Lite Signup Ad Assets Scenario',
      activity: [
        {
          name: 'adAssetsStep',
          value: 'Ad assets logger',
        },
      ],
    },
    {
      name: 'pmaxLiteTargeting',
      value: 'Pmax Lite Signup Targeting Scenario',
      activity: [
        {
          name: 'locationTargeting',
          value: 'location targeting logger',
        },
        {
          name: 'audienceSignalTargeting',
          value: 'audience signal logger',
        },
        {
          name: 'searchThemesTargeting',
          value: 'search themes logger',
        },
      ],
    },
    {
      name: 'pmaxLiteBudget',
      value: 'Pmax Lite Signup Budget Scenario',
      activity: [
        {
          name: 'budgetStep',
          value: 'Budget logger',
        },
      ],
    },
    {
      name: 'pmaxLiteAccountDetails',
      value: 'Pmax Lite Signup Account Details Scenario',
      activity: [
        {
          name: 'accountDetailsStep',
          value: 'AccountDetails logger',
        },
      ],
    },
  ],
};
